export const generateStack = (
  code?: string | number,
  stack?: string,
  message?: string,
  time?: string,
) => {
  return `
    Error Code: ${code}
    Error Message: ${message}
    
    Technical Details:
    ------------------
    Error Timestamp: ${time}
    Error Stack Trace:
        ${stack}
  `
}
